/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminNoticeDto } from '../../models/admin-notice-dto';
import { CreateAdminNoticeDto } from '../../models/create-admin-notice-dto';

export interface AdminNoticeControllerCreate$Params {
      body: CreateAdminNoticeDto
}

export function adminNoticeControllerCreate(http: HttpClient, rootUrl: string, params: AdminNoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, adminNoticeControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminNoticeDto>;
    })
  );
}

adminNoticeControllerCreate.PATH = '/api/admin-notice';
